import Login from 'CustomModules/SteelOApp/pages/Login/Login'

export const Routes = []

export const Override = {
  loginComponent: Login
}



// WEBPACK FOOTER //
// ./src/customization/SteelOApp/routes.js